import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[agAutofocus]',
})
export class AgAutoFocusDirective implements AfterViewInit, OnChanges {
  @Input()
  get agAutofocus(): boolean {
    return this._autofocus;
  }
  set agAutofocus(value: string | boolean) {
    this._autofocus = coerceBooleanProperty(value);
  }

  @Input()
  get selectText(): boolean {
    return this._selectText;
  }
  set selectText(value: string | boolean) {
    this._selectText = coerceBooleanProperty(value);
  }

  private _autofocus: boolean;
  private _selectText: boolean;
  private _focus = false;

  constructor(private _elementRef: ElementRef<HTMLInputElement | HTMLTextAreaElement>) {}

  @HostListener('focus') onFocus() {
    this._focus = true;
  }
  @HostListener('blur') onBlur() {
    this._focus = false;
  }

  ngAfterViewInit() {
    if (this._autofocus) {
      this._setFocus();
    }
  }

  ngOnChanges(change: SimpleChanges): void {
    if (change.agAutofocus?.currentValue) {
      this._setFocus();
    }
  }

  private _setFocus() {
    setTimeout(() => {
      const element = this._elementRef.nativeElement;
      if (!this._focus) {
        element.focus();
        if (this._selectText && element.value) {
          element.select();
        }
      }
    }, 0);
  }
}
